// import HtmlDom from "../main/HtmlDom";
// import commonAddBubbleTemplate from "../templates/commonAddBubble.html";
// import addButtonTemplate from "../templates/addButton.html";
// import groupHeaderTemplate from "../templates/groupHeader.html";
import AI_helperItemClass from "./ai_helperItemClass";

let AI_helperPrivilegeClass = function(item) {
	this.header = 'ПРИВИЛЕГИЯ';
	this.crm = item.crm;
	this.id = 0;
	this.complect = item.complect;
	this.group = item.complect_group;
	this.item = item;
	this.folderURL = this.crm.folderURL;
	this.debug = this.crm.debug;
	this.service_debug = this.crm.service_debug;
	this.user = this.crm.user;
	this.goods = {};
	//this.makePost = this.crm.makePost;
	this.ids = this.group.ids;
	this.selected_items = [];
	this.addButton = null;
	this.containers = {};

	this.init = function () {
		this.createBubble();
		this.get_privilege_bubble(this.item.id, this.item.colorGroup);
		// this.addButton = new HtmlDom(addButtonTemplate, {}, this);
	};
	this.get_privilege_bubble = function (id, color) {
		let self = this;
		let data = {id: id, color: color};
		self.crm.makePost('aiHelper', 'get_privilege_bubble', data, null, function (respond) {
			if (respond.status === 'OK') {
				self.bubbleLoaded(respond.data);
			} else {
				self.bubble.content.innerHTML = 'ОШИБКА!!!';
				//self.bubbleDestroy();
			}
		});
	};
	this.srt = function (o) {
		let arr = [];
		for (let k in o) {
			if (Object.prototype.hasOwnProperty.call(o, k)) {
				arr[arr.length] = o[k];
			}
		}
		arr.sort(function (a, b) {
			return a.name_trunc > b.name_trunc
		});
		return arr;
	};
	this.bubbleLoaded = function (items) {
		if (this.containers.bubbleItems) {
			// this.containers.bubbleItems.innerHTML = '';
			// this.containers.bubbleItems.appendChild(this.addButton);
			// let table_goods = document.createElement('table');
			// table_goods.style.width = '100%';
			// this.containers.bubbleItems.appendChild(table_goods);
			let bubble_items = [];
			let i = 0;
			let items2 = this.srt(items);
			// table_goods.innerHTML = groupHeaderTemplate;
			let self = this;
			for (let k in items2) {
				if (Object.prototype.hasOwnProperty.call(items2, k)) {
					let v = items2[k];
					v.count = v.package;
					v.cnt_per_all = this.amountAct;
					bubble_items[k] = new AI_helperItemClass(v, self.group, function (param) {
						self.group.check_complect(param);
					},'groupAdd');
					bubble_items[k].selected = false;
					if (bubble_items[k].controls.addButtonGroupAdd) {
						bubble_items[k].selected = false;
						bubble_items[k].controls.addButtonGroupAdd.setAttribute('value', 'Выбрать');

						bubble_items[k].controls.addButtonGroupAdd.onclick = function () {
							if (bubble_items[k].selected) {
								bubble_items[k].domGroupAdd.style.background = "#fff";
								bubble_items[k].controls.addButtonGroupAdd.setAttribute('value', 'Выбрать');
								bubble_items[k].selected = false;
							} else {
								bubble_items[k].domGroupAdd.style.background = "#ffe787";
								bubble_items[k].controls.addButtonGroupAdd.setAttribute('value', 'Отменить');
								bubble_items[k].selected = true;
							}
							if (bubble_items)
								self.collect_selected_items(bubble_items);
						}
					}
					if (window.in_array(bubble_items[k].id, self.ids)) {
						delete (bubble_items[k]);
						bubble_items.splice(k, 1);
					} else {
						// bubble_items[k].appendGroupAdd(table_goods);
						i++;
					}
				}
			}
			if (i <= 0) console.log('В ЭТОЙ ГРУППЕ ДРУГИХ ТОВАРОВ НЕТ!')
			// 	this.containers.bubbleItems.innerHTML = '<br /><br />В ЭТОЙ ГРУППЕ ДРУГИХ ТОВАРОВ НЕТ!<br /><br /><br /><br />';
		}
	};
	this.collect_selected_items = function (items) {
		this.selected_items = [];
		for (let k in items) {
			if (Object.prototype.hasOwnProperty.call(items, k)) {
				// let item = items[k];
				if (items[k]) {
					if (items[k].selected && this.ids.indexOf(items[k].id) === -1) {
						this.selected_items[this.selected_items.length] = items[k];
					}
				}
			}
		}
		if (this.selected_items.length > 0)
			this.addButton.style.display = 'block';
		else
			this.addButton.style.display = 'none';
		//console.log(this.selected_items);
	};
	this.showBubble = function() {
		if (this.bubble) this.bubble.style.display = 'block';
	};
	this.hideBubble = function() {
		this.selected_items = [];
		if (this.bubble) this.bubble.parentNode.removeChild(this.bubble);
		if (this.group && this.group.bubbleDestroy) this.group.bubbleDestroy();
	};
	this.addButtonClick = function() {
		for (let k in this.selected_items) {
			if (Object.prototype.hasOwnProperty.call(this.selected_items, k)) {
				let item = this.selected_items[k];
				item.addItem();
				item.domGroupAdd.style.display = "none";//destroy();
				//	console.log(item);
			}
		}
		this.selected_items = [];
		this.addButton.style.display = "none";
		this.hideBubble();
		this.complect.check_complect();
	};
	this.createBubble = function() {
		// this.bubble = new HtmlDom(commonAddBubbleTemplate, {header:this.header}, this);
		// this.bubble.style.display='none';
		// this.containers.bubbleCats = this.bubble.querySelectorAll('[containers="cats"]')[0];
		// this.containers.bubbleItems = this.bubble.querySelectorAll('[containers="items"]')[0];
		// this.crm.mainContainer.appendChild(this.bubble);
		// this.containers.bubbleCats.parentNode.style.display = 'none';
	};
	this.init();
}; //class
export default AI_helperPrivilegeClass;
